module.exports = __webpack_public_path__ + "static/media/even_profile_background.ca733a85.jpg";